import React from "react";
import { Dayjs } from "dayjs";
import { useSelector } from "react-redux";
import { FieldValues } from "react-hook-form";

import FormGenerator from "../../form/FormGenerator";
import { User, userApi } from "../../api/user/user.service";
import { selectedCustomersIdsSelector } from "../../authentication/auth-slice";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";
import { scheduledReportsApi, ScheduledReportTemplate } from "../../api/scheduled-reports/scheduled-report.service";

const { useGetTemplatesQuery, useGetReportFrequencyQuery } = scheduledReportsApi;
const { useGetUserQuery } = userApi;

export type SubscriptionSubmitValues = {
  send_on_hour: Dayjs;
  /**
   * while editing users are populated from different API while during create from different API
   * both are using different models
   */
  user: { userid?: string; id?: string };
  frequency: string;
  report_template_id: ScheduledReportTemplate;
  enable: {
    id: boolean;
    label: string;
  };
};

interface Props {
  defaultValues: FieldValues;
  handleSubmit: (form_values: SubscriptionSubmitValues) => void;
  loading?: boolean;
}

const ScheduledReportsSubscriptionsForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false }) => {
  const customer_ids = useSelector(selectedCustomersIdsSelector) as string[];
  const { data: frequency_list = [], isFetching: frequency_list_fetching } = useGetReportFrequencyQuery();
  const { data: template_list = [], isFetching: template_list_fetching } = useGetTemplatesQuery();

  const { data: user_list = [], isFetching } = useGetUserQuery({ customerIds: customer_ids.toString() });
  const fields: FormFieldType[] = [
    {
      type: FormFieldTypesAllowed.Dropdown,
      label: "User",
      id: "user",
      multiple: false,
      options: user_list,
      loading: isFetching,
      required: "Field is required",
      getOptionLabel: (user: User) => `${user.email}`,
      // getOptionLabel: (user: User) => `${user.firstName} ${user.lastName} (${user.email})`,
    },
    {
      type: FormFieldTypesAllowed.Dropdown,
      label: "Frequency",
      id: "frequency",
      multiple: false,
      options: frequency_list,
      loading: frequency_list_fetching,
      required: "Field is required",
    },
    {
      type: FormFieldTypesAllowed.Time,
      label: "Time",
      id: "send_on_hour",
      required: "Field is required",
      views: ["hours"],
    },
    {
      type: FormFieldTypesAllowed.Dropdown,
      label: "Template",
      id: "report_template_id",
      multiple: false,
      options: template_list,
      loading: template_list_fetching,
      required: "Field is required",
      getOptionLabel: (template: ScheduledReportTemplate) => template.name,
    },
    {
      type: FormFieldTypesAllowed.Dropdown,
      label: "Enabled",
      id: "enable",
      multiple: false,
      options: [
        { id: true, label: "Enabled" },
        { id: false, label: "Disabled" },
      ],
      required: "Field is required",
    },
  ];
  return (
    <FormGenerator
      defaultValues={defaultValues}
      formFields={fields}
      handleFormSubmit={handleSubmit}
      className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
      loading={loading}
    />
  );
};

export default ScheduledReportsSubscriptionsForm;
